module.exports = __webpack_public_path__ + "img/sqty_banner.7119c1dc.png";